export default "https://studio-ui-deployments.apollographql.com/build/static/assets/invincible.1b432544ff0eb83cc1f1f21f9712ab59.wav";